export const buildVersion = {
  version: '1.4',
  buildNumber: 65,
  commit: '1e08b8f7f',
};
